<template>
  <div>
    <!-- v-if="componenteEvento.agregar_submodulo" -->
    <v-row>
      <v-col class="d-flex flex-row-reverse">
        <TableButtonComp normalButton iconBut="fas fa-plus" textButton="Crear colegios"
          @click="abrirFormColegios('crear', null)" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <ComundataTableComp placeholderTextsearch="Buscar colegios" :items="colegios" :headers="Colegioheaders"
          rowsPerPageText="Colegios por página:" noResultsText="Sin Colegios por Mostrar" whitSearch>
          <template v-slot:web="{ item }">
            <span v-if="item.web_colegio">{{
              item.web_colegio + item.extension
            }}</span>
            <span v-else>
              <v-chip color="alert">
                <v-icon>mdi-alert-circle-outline</v-icon>
                Sin enlace
              </v-chip>
            </span>
          </template>

          <template v-slot:tipo="{ item }">
            <v-chip :color="item.es_sucursal ? 'success' : 'primary'" pill dark small class="font-weight-black">
              {{ item.es_sucursal === 0 ? "Principal" : "Sucursal" }}
            </v-chip>
          </template>

          <template v-slot:sucursal="{ item }">
            <TableButtonComp textButton="Ver sedes" iconBut="fa-eye" @click="verSucursalesColegio(item)" />
          </template>

          <template v-slot:action_ver="{ item }">
            <!-- v-if="componenteEvento.visualizar_submodulo" -->
            <template>
              <TableButtonComp verButton @click="verColegio(item)" tooltipText="Ver colegio" />
            </template>
          </template>

          <template v-slot:action_editar="{ item }">
            <TableButtonComp editButton @click="abrirFormColegios('editar', item)" tooltipText="Editar colegio" />
          </template>

          <template v-slot:action_config="{ item }">
            <TableButtonComp configButton @click="editConfig(item)" tooltipText="Configurar módulos del colegio" />
          </template>
        </ComundataTableComp>
      </v-col>
    </v-row>

    <!-- modal  sucursales por colegios-->

    <ComunDialogComp v-model="modal_sucursal" maxWidth="1000" @close-modal="modal_sucursal = false">
      <template v-slot:title>
        Sedes del colegio: {{ ColegioSucursal.nombre_colegio }}
      </template>
      <template v-slot:body>
        <v-card v-if="sucursales.length > 0">
          <!-- <v-text-field outlined label="Append" append-icon="mdi-map-marker"></v-text-field> -->

          <v-col class="d-flex justify-end ">
            <v-text-field label="Buscar" v-model="search2" append-icon="fa-search" />
          </v-col>

          <v-data-table :headers="cabecera_sucursal" :items="sucursales" :search="search2" class="elevation-1 black--text"
            fixed-header>

          </v-data-table>
        </v-card>
        <template v-else>
          <div class="py-10 black--text">
            <v-alert outlined type="warning" prominent border="left">
              {{ mensajeSucursal }}
            </v-alert>
          </div>
        </template>
      </template>
    </ComunDialogComp>


    <!--modal visualizacion-->
    <ComunDialogComp v-model="viewColegio" max-width="900px" title="Colegio " @close-modal="viewColegio = false">
      <template v-slot:body>
        <v-row>
          <v-col cols="12" md="6">
            <v-card outlined>
              <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                Información del colegio
              </v-card-title>
              <v-card-text>
                <ul>
                  <li><strong>RUC : </strong> {{ vista_colegio.ruc_colegio }}</li>
                  <li><strong>FECHA DE CONSTITUCIÓN : </strong> {{ vista_colegio.fec_constitucion }}</li>
                  <li><strong>CORREO : </strong> {{ vista_colegio.correo_colegio }}</li>
                  <li><strong>TELÉFONO : </strong> {{ vista_colegio.telf_colegio }}</li>
                  <li><strong>WEB : </strong> {{ vista_colegio.web_colegio + vista_colegio.extension }} </li>
                  <li><strong>RESOLUCIÓN : </strong> {{ vista_colegio.resolucion_colegio }}</li>
                  <li><strong>PAÍS : </strong> {{ vista_colegio.nombre_pais }}</li>
                  <li><strong>DEPARTAMENTO : </strong> {{ vista_colegio.nombre_ubicacion1 }}</li>
                  <li><strong>PROVINCIA : </strong> {{ vista_colegio.nombre_ubicacion2 }}</li>
                  <li><strong>DISTRITO : </strong> {{ vista_colegio.nombre_ubicacion3 }}</li>
                  <li><strong>DIRECCIÓN : </strong> {{ vista_colegio.direc_colegio }}</li>
                  <li><strong>DIRECCIÓN REGIONAL DE EDUCACIÓN : </strong> {{ vista_colegio.dre }}</li>
                  <li><strong>UNIDAD DE GESTIÓN LOCAL :</strong> {{ vista_colegio.ugel }}</li>
                  <li><strong>UNIDAD DE GESTIÓN LOCAL :</strong> {{ vista_colegio.ugel }}</li>
                  <li><strong>ESLOGAN : </strong> {{ vista_colegio.slogan_colegio }}</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col class="d-flex justify-center">
                        <v-img v-if="vista_colegio.logo_colegio && !previewImgLogo"
                          :src="`${rutaSpace}${vista_colegio.logo_colegio}`"
                          :lazy:src="`${rutaSpace}${vista_colegio.logo_colegio}`" aspect-ratio="1" dark contain
                          class="fondo_add_img" max-width="200px">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-subtitle class="text-center primary--text py-1">
                    {{ vista_colegio.nombre_colegio }}
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card outlined>
                  <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                    Responsable del colegio
                  </v-card-title>
                  <v-card-text>
                    <ul>
                      <li><strong>NOMBRE :</strong>{{ vista_colegio.responsable_nombre }}</li>
                      <li><strong>TELÉFONO : </strong>{{ vista_colegio.responsable_telf }}</li>
                      <li><strong>CORREO : </strong>{{ vista_colegio.responsable_correo }}</li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>


          </v-col>
        </v-row>


      </template>
    </ComunDialogComp>


    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @changeDpto="getDepartamentos"
      @changeProv="getProvincias" @changeDist="getDistritos" @reloadMain="loadMain()" @close="CloseModal" />

    <component :is="compConfig" :modalConfig="estadoModalConfig" @close="estadoModalConfig = false"
      :parametros="parametroColegioConfig" />

  </div>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "../../../helpers/axios";
import { mapMutations,  mapActions } from "vuex"; //mapGetters

import ColegioFormComp from "./components/ColegioFormComp.vue";
import ColegioConfigComp from "./components/ColegioConfigComp.vue";

import { validationRules } from "../../../helpers/validatorHelpers";
import ComundataTableComp from "./../../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "./../../../components/ComponentsEst/TableButtonComp.vue";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";

import { Colegioheaders } from "../../../helpers/headersTable.js";

export default {
  name: "ManagerColegio",
  components: {
    ColegioFormComp,
    ColegioConfigComp,
    ComundataTableComp,
    TableButtonComp,
    ComunDialogComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 1, id_modulo: 4 }, //sud_modulo y modulo

    datoLogin: sessionStorage,
    Colegioheaders,
    evento: "agregar",
    title: "",
    search: "",
    colegios: [],
    headers: [
      {
        text: "COLEGIO",
        value: "nombre_colegio",
        class: "secondary black--text",
      },
      { text: "RUC", value: "ruc_colegio", class: "secondary black--text" },
      {
        text: "CORREO",
        value: "correo_colegio",
        class: "secondary black--text",
      },
      { text: "SITIO WEB", value: "web", class: "secondary black--text" },
      {
        text: "TIPO",
        align: "center",
        value: "tipo",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "SEDES",
        align: "center",
        value: "sucursal",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "VER COLEGIO",
        value: "action_ver",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
      {
        text: "EDITAR",
        value: "action_editar",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
      {
        text: "CONFIGURAR MÓDULOS",
        value: "action_config",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
    ],
    modal_sucursal: false,
    search2: "",
    ColegioSucursal: [],
    sucursales: [],
    mensajeSucursal: "",
    cabecera_sucursal: [
      {
        text: "COLEGIO SUCURSAL",
        value: "nombre_colegio",
        class: "secondary black--text",
      },
      { text: "RUC", value: "ruc_colegio", class: "secondary black--text" },
      {
        text: "TELÉFONO",
        value: "telf_colegio",
        class: "secondary black--text",
      },
    ],
    viewColegio: false,
    vista_colegio: [{ logo_colegio: null }],
    Colegios_padres: [],

    compConfig: null,
    estadoModalConfig: true,
    parametroColegioConfig: [],
    previewImgLogo: "",
    imageSaveLogo: "",
    rutaSpace: BUCKET_ORIGIN_SPACE,
    // rul: {
    //   required: (value) => !!value || "Campo Requerido",
    //   inputReq: (value) => !!value || "Campo Requerido",
    //   selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
    //   selectReq2: (value) =>
    //     (value || "").length < 0 || "Debe seleccionar un campo de la lista",
    //   email: (value) =>
    //     /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
    //     "El correo Electrónico es incorrecto",
    //   min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
    //   min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
    //   min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
    //   max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
    //   max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
    //   max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
    //   max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
    //   max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
    //   max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
    //   max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
    //   max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
    //   max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
    //   email_null: (value) => {
    //     if (value == "") {
    //       return false;
    //     } else {
    //       const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
    //       return pattern.test(value) || "El correo Electrónico es incorrecto";
    //     }
    //   },
    // },
    Allpaises: [],
    //VARIABLES PARA ABRIR COMPONENTES 
    compName: null,
    estadoComponente: true,
    parametroComp: [],

    paises: [],
    departamentos: [],
    provincias: [],
    distritos: []


  }),
  computed: {
    // ...mapGetters("login", ["componenteEvento"]),
    // es_sucursal() {
    //   return this.editedItem.es_sucursal === "false" ? "No" : "Si";
    // },

    validationRules() {
      return validationRules
    }
  },

  mounted() {
    this.loadMain();
  },

  created() {
    // this.actualizarParamentro();
    this.getAllPaises();
    this.getAllTiposDoc();
  },

  methods: {
    ...mapActions({
      parametroComponente: "login/parametroComponente",
      getAllTiposDoc: "getAllTiposDoc",
      getAllPaises: "getAllPaises",
      getDptoUbigeo1: "getDptoUbigeo1"
    }),
    async actualizarParamentro() {
      await this.parametroComponente(this.paramComponente);
    },
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    async loadMain() {
      this.colegios = [];
      this.Colegios_padres = [];
      this.parametroColegioConfig = [];
      this.parametroColegioForm = [];

      this.title = "";

      await this.getAllColegios();

      // await this.getAllColegiosPadres();
    },
    /** 
     _____________________________________
    |  FUNCION OBTENER TODOS LOS PAÍSES */
    async getPais() {
      try {
        const response = await axios.get(
          "/mantenimiento/paises/paisesConfigurados/"
        );
        this.paises = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     __________________________________
    |  FUNCION OBTENER DEPARTAMENTOS */
    async getDepartamentos(idPais) {

      try {
        let response = await axios.get("/mantenimiento/ubicacion1/" + idPais);
        this.parametroComp.departamentos = response.data
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _______________________________
    |  FUNCION OBTENER PROVINCIAS */
    async getProvincias(idDpto) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + idDpto);
        this.parametroComp.provincias = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     ______________________________
    |  FUNCION OBTENER DISTRITOS */
    async getDistritos(idDtro) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + idDtro);
        this.parametroComp.distritos = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _______________________________________
    |  FUNCION OBTENER TODOS LOS COLEGIOS */
    async getAllColegios() {
      try {
        const response = await axios.get("/manager/colegio")
        this.colegios = response.data;

      } catch (error) {
        console.log(error);
      } finally {
        this.getPais();
      }

    },
    /** 
     ______________________________________________________
    |  FUNCION ABRIR COMPONENTE MODAL FORMULARIO COLEGIO */
    async abrirFormColegios(action, data) {

      console.log('RECIBE', data);

      let itemControl = {}
      itemControl.dre = action == 'crear' ? '' : data.dre.description
      itemControl.id_dre = action == 'crear' ? '' : data.dre.id
      itemControl.ugel = action == 'crear' ? '' : data.ugel.description
      itemControl.id_ugel = action == 'crear' ? '' : data.ugel.id

      let itemSend = { ...data, ...itemControl }

      const items = action == 'crear' ? [] : itemSend;

      action == 'crear' ? null : (this.getDptoUbigeo1(data.id_pais), await this.getProvincias(data.id_ubicacion1), await this.getDistritos(data.id_ubicacion2));
      this.title = action == 'crear' ? 'Crear colegio' : 'Editar colegio';
      this.evento = action == 'crear' ? 'agregar' : 'editar';
      this.parametroComp = {
        evento: this.evento,
        title: this.title,
        items,
        paises: this.paises,
        allPaises: this.$store.state.paises,
        allTiposDoc: this.$store.state.tipoAllDocumentos,
        departamentos: this.$store.state.DptoUbigeo1,
        provincias: this.parametroComp.provincias,
        distritos: this.parametroComp.distritos
      };
      this.compName = "ColegioFormComp";
      this.estadoComponente = true;
    },
    /** 
     ____________________________________
    |  FUNCION CERRAR MODAL COMPONENTE */
    CloseModal() {
      this.estadoComponente = false;
    },
    /** 
     ___________________________________
    |  FUNCION EDITAR CONFIGURACIONES */
    async editConfig(item) {
      this.parametroColegioConfig = item;
      this.compConfig = "ColegioConfigComp";
      this.estadoModalConfig = true;
    },
    /** 
     ___________________________
    |  FUNCION VER SUCURSALES */
    async verSucursalesColegio(item) {
      this.ColegioSucursal = item;
      var id = item.id;
      try {
        let response = await axios.get(
          "/manager/colegio/sucursales/" + id + ""
        );
        this.sucursales = response.data;

        if (this.sucursales.length === 0) {
          this.mensajeSucursal = "Este colegio no tiene ninguna sede";
        }
        this.modal_sucursal = true;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     _________________________
    |  FUNCION VER COLEGIO  */
    async verColegio(item) {
      this.viewColegio = true;
      let id = item.id;
      try {
        let response = await axios.get("/manager/colegio/VC/" + id + "");
        this.vista_colegio = response.data;
        console.log('Vista de colegio', this.vista_colegio);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ____________________________________
    |  FUNCION VER COLEGIOS SUCURSALES */
    async getAllColegiosPadres() {
      await axios
        .get("/manager/colegio/colegiosPadres")
        .then((response) => {
          this.Colegios_padres = response.data;
        })

        .catch((error) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        });
    },
  },
};
</script>

<style lang="scss">
thead tr:first-child th:first-child {
  background-color: #fff
}

td:first-child {
  background-color: #ffffff
}

th:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
}

td:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
}

.fondo_add_img {
  padding: 10px;
  cursor: pointer;
  cursor: hand;
}

.grid-conttitle {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 9fr 1fr;

}
</style>